import { createContext, useContext } from 'react';
import type { AnalyticsContextValue } from './types';

export const AnalyticsContext = createContext<AnalyticsContextValue | null>(null);

export function useAnalyticsContext(): AnalyticsContextValue {
  const context = useContext(AnalyticsContext);

  if (!context) {
    throw new Error('useAnalyticsContext must be used within AnalyticsProvider');
  }

  return context;
}
